import {emotionStyled, tokens} from '@packages/utilities/styled';
import {SearchableListBoxView} from '../../SearchableList/SearchableListBox';
import {SearchableListItemGroupView} from '../../SearchableList/SearchableListBox/SearchableListBox.styles';
import {GroupLabelView} from './AutocompleteGroupLabel';

export const EmptyStateWrapper = emotionStyled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '$6',
  padding: `${tokens.ui.rowItem.padding.compact.vertical} ${tokens.ui.rowItem.padding.compact.left}`,
});

export const AutocompleteListBoxView = emotionStyled(SearchableListBoxView)(
  {
    backgroundColor: '$uiAutocompleteListBoxBackground',
    borderRadius: '$2',
    boxShadow: '$menu',
    padding: tokens.ui.autocomplete.listBox.padding,
  },
  {
    componentName: 'AutocompleteListBox',
    variants: {
      hasGroupDividers: {true: {}},
      isVirtualized: {
        true: {
          minHeight: 'fit-content',
        },
      },
    },
    compoundVariants: [
      {
        conditions: {
          hasGroupDividers: true,
          isVirtualized: true,
        },
        css: {
          [`& ${SearchableListItemGroupView}:not(:first-child) ${GroupLabelView}`]:
            {
              /**
               * Give a little more breathing room between a group divider and the next label in virtualized lists.
               */
              padding: tokens.ui.autocomplete.label.virtualized.padding,
            },
        },
      },
    ],
  }
);

export const AutocompleteListBoxContentView = emotionStyled('div')(
  {
    alignContent: 'center',
    flex: 1,
    overflowY: 'auto',
    position: 'relative',
  },
  {
    componentName: 'AutocompleteListBoxContentView',
  }
);
